import React from "react";
import { Link } from "react-router-dom";

export default function MentionsLegales() {
  return (
    <div className="mentions-legales-page">
      <div className="mentions-legales-content">
        <Link to="/" className="mentions-legales-back">
          ← Retour à l'accueil
        </Link>
        <h1>Mentions légales</h1>
        <div className="mentions-legales-body">
          <section>
            <h2>1. Présentation</h2>
            <p>
              Ce tableau de bord est édité par <em>l'Audiar</em>. Cette plateforme de visualisation en ligne permet de consulter ou extraire des données et indicateurs à différentes échelles territoriales. Les données présentées sont publiques (disponibles en open data) ou transmises directement par les collectivités membres de l’agence qui acceptent de les verser dans ce tableau de bord.
            </p>
          </section>

          <section>
            <h2>2. Éditeur et responsabilités</h2>
            <p><strong>Éditeur du service :</strong> Audiar (Siret : 77773407000041)</p>
            <p>3 rue Geneviève de Gaulle-Anthonioz - CS 40716 - 35207 Rennes Cedex 2</p>
            <p>Tél. : 02 99 01 86 40</p>
            <p>
              <a href="mailto:communication@audiar.org">communication@audiar.org</a>
            </p>
            <p><strong>Directeur de la publication :</strong> Alain Bénesteau</p>
          </section>

          <section>
            <h2>3. Mise en garde</h2>
            <p>
              L'information contenue dans ces pages n'est fournie qu'à titre informatif et ne prétend aucunement à l’exhaustivité. <em>L'Audiar</em> décline toute responsabilité quant au contenu des présentes pages et à l'utilisation qui pourrait en être faite. Il appartient aux utilisateurs de vérifier que leur configuration permet un accès sécurisé aux tableaux de bord. En accédant à ces tableaux de bord et en les utilisant, vous reconnaissez être lié par les présentes Conditions d'utilisation et vous vous engagez à les respecter.
            </p>
          </section>

          <section>
            <h2>4. Droits de propriété intellectuelle</h2>
            <h3>4.1</h3>
            <p>
              La structure générale, les textes, visualisations de données et tous les éléments composant ces tableaux de bord sont protégés et relèvent de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle.
            </p>
            <h3>4.2</h3>
            <p>La réutilisation des visualisations et données présentées dans ce tableau de bord est possible en citant explicitement :</p>
            <ul>
              <li>la source originale des données</li>
              <li><em>l'Audiar</em> comme source des traitements et analyses</li>
            </ul>
          </section>

          <section>
            <h2>6. Liens hypertextes</h2>
            <h3>6.1</h3>
            <p>
              Les liens hypertextes présents ne sauraient engager la responsabilité de <em>l'Audiar</em>.
            </p>
          </section>

          <section>
            <h2>7. Cookies - suivi d'audience</h2>
            <p>
              Les données de trafic ont uniquement pour finalité de permettre l'analyse de la fréquentation afin d'améliorer le contenu. Vous pouvez vous opposer à l'enregistrement de cookies en configurant les paramètres de votre navigateur.
            </p>
          </section>

          <section>
            <h2>8. Modification des mentions légales</h2>
            <p>
              <em>L'Audiar</em> e réserve le droit de modifier les présentes mentions légales et vous invite à les consulter régulièrement.
            </p>
          </section>

          <p className="mentions-legales-update">Dernière mise à jour : Mai 2025</p>
        </div>
      </div>
    </div>
  );
}
